.d2{padding:0.5rem;}